<div class="shadow-md transition-all cursor-pointer hover:shadow-xl relative px-4 pt-8 pb-4 bg-white mobile:py-10"
  [class.h-full]="item.socialName==='promotion'" [class.!p-4]="item.socialName==='promotion'" (click)="showDetails()">

  <ng-container *ngIf="item.socialName==='promotion'">
    <ig-image [src]="item?.cover?.source" class="h-full" cls="w-full h-full object-cover cursor-pointer"></ig-image>
  </ng-container>

  <ng-container *ngIf="item.socialName!=='promotion'">
    <div *ngIf="item?.pinnedTime" class="bookmark text-red-400" matTooltip="This is pinned top"></div>

    <div class="relative">
      <ig-image [src]="item?.cover?.source" [alt]="item?.name" cls="w-full object-cover h-[198px]"></ig-image>
    </div>

    <div class="my-4 mobile:my-5">
      <p
        class="h-[82px] flex items-center flex-[4] pl-4 text-gray-700 font-semibold !text-lg overflow-hidden max-lines-3 mobile:h-auto">
        <span *ngIf="!isSearchName">{{item?.title || item?.name}}</span>
        <span *ngIf="isSearchName" [innerHTML]="(item?.title || item?.name)| highlight:keyword"></span>
      </p>
    </div>

    <div class="bg-[#f3f3f3] p-4 h-48 mobile:h-auto">
      <span *ngIf="!frontendSettings?.customSettings?.isHideEditorChoice && item?.isChoice"
        class="px-2 py-1 relative -top-1.5 mb-1 inline-block bg-gradient-to-r from-[#773bf2] to-[#b04aea] text-xs text-white">
        {{getItemType()==='event' ? editorChoiceText.editorChoiceForEvent
        : editorChoiceText.editorChoiceForPlace}}</span>
      <ng-container *ngIf="getItemType()==='event'">
        <div class="text-base text-gray-600 mt-1 font-semibold">{{item?.timeTwoLines?.date}}</div>
        <div class="text-sm text-gray-600 font-semibold mb-1">
          {{item?.eventTimes?.length>1?'Multiple times':item?.timeTwoLines?.time}}</div>
        <div class="text-xs text-gray-800">HOSTED BY: {{item?.owner?.name}}</div>
        <div class="text-xs text-gray-600 mt-1">Address: {{item?.address?.address}}</div>

      </ng-container>
      <ng-container *ngIf="getItemType()==='place'">
        <div class="text-xs text-gray-800">Category:
          <span *ngIf="isSearchCategory" [innerHTML]="getDisplayCategory(item)| highlight:keyword"></span>
          <span *ngIf="!isSearchCategory">{{ getDisplayCategory(item) }}</span>
        </div>

        <div class="text-xs text-gray-600 mt-1">
          <span *ngIf="isSearchAddress"
            [innerHTML]="(item.address?.address || '(no location)')| highlight:keyword"></span>
          <span *ngIf="!isSearchAddress">{{ item.address?.address || '(no location)' }}</span>
        </div>
      </ng-container>

    </div>

    <ig-button [style]="'flat'" cls="w-full mt-4" (trigger)="showDetails()">{{getItemType()}} Details</ig-button>
  </ng-container>
</div>